import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function CursorDot() {
  useEffect(() => {
    const dot = document.createElement("div");
    dot.className = "cursor-dot";
    document.body.appendChild(dot);
    const onMove = (e) => {
      dot.style.transform = `translate(${e.clientX - 4}px, ${e.clientY - 4}px)`;
    };
    const onOver = (e) => {
      const t = e.target;
      if (t.closest && t.closest("a, button, [role='button'], input, textarea")) {
        dot.style.width = "32px"; dot.style.height = "32px";
        dot.style.transform += " translate(-12px, -12px)";
      } else {
        dot.style.width = "8px"; dot.style.height = "8px";
      }
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      dot.remove();
    };
  }, []);
  return null;
}

function App() {
  return (
    <div className="App grain">
      <CursorDot />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#162E24",
            border: "1px solid #264738",
            color: "#F8F7F3",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
